import { combineReducers } from 'redux'
import { clientInvitePanelReducer } from './clientInvitePanel'

export const clientInviteReducer = combineReducers({
  clientInvitePanel: clientInvitePanelReducer
})
